import { render, staticRenderFns } from "./AppServiceList.vue?vue&type=template&id=5cf68517&"
import script from "./AppServiceList.vue?vue&type=script&lang=js&"
export * from "./AppServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports